<template>
  <div>
    <div style="display: flex" v-show="detailDialog">
      <div class="flex">
        <div>
          <!-- <el-select
            class="btn"
            clearable
            v-model="isRobot"
            filterable
            placeholder="机器人筛选"
            size="mini"
          >
            <el-option
              v-for="item in isRobotOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select> -->
          <el-input
            placeholder="订单id"
            clearable
            class="btn orderId"
            v-model="SearchOrderId"
            size="mini"
          ></el-input>
          <el-input
            placeholder="账户id"
            clearable
            class="btn accountId"
            v-model="defalutAccountId"
            size="mini"
          ></el-input>
          <el-select
            class="btn"
            clearable
            v-model="defalutSymbolId"
            filterable
            placeholder="请选择symbolId"
            size="mini"
          >
            <el-option
              v-for="item in pairList"
              :key="item.id"
              :label="item.symbol"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-select
            class="btn"
            clearable
            v-model="stateType"
            size="mini"
            filterable
            placeholder="请选择订单状态"
          >
            <el-option
              v-for="item in stateOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-select
            class="btn"
            clearable
            v-model="orderType"
            size="mini"
            filterable
            placeholder="请选择订单类型"
          >
            <el-option
              v-for="item in orderTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-select
            class="btn"
            clearable
            v-model="orderSide"
            size="mini"
            filterable
            placeholder="请选择下单方向"
          >
            <el-option
              v-for="item in orderSideOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-select
            class="btn user-range"
            v-model="userRange"
            size="mini"
            placeholder="用户范围"
          >
            <el-option
              v-for="item in userRangeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-date-picker
            v-model="createdTimeRange"
            class="btn time-range"
            size="mini"
            type="daterange"
            align="right"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            unlink-panels
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
          <el-button
            type="primary"
            @click="searchId"
            size="mini"
            style="margin-right: 10px"
            >搜索</el-button
          >
          <el-button
            v-if="$hasPerm('tenant:spot_order_limit:export_data')"
            size="mini"
            @click="getExcel"
            >导出Excel</el-button
          >
        </div>
        <!-- <div>
          <el-input
            placeholder="账户id"
            clearable
            class="btn"
            v-model="accountId"
            size="mini"
          ></el-input>
          <el-input placeholder="symbolId" clearable class='btn' v-model="symbolId"></el-input>
          <el-select
            v-model="symbolId"
            class="btn"
            clearable
            filterable
            placeholder="请选择交易对"
            size="mini"
          >
            <el-option
              v-for="item in pairList"
              :key="item.id"
              :label="item.symbol"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <el-button type="danger" size="mini" @click="cancelAllOrder"
            >一键撤销</el-button
          >
        </div> -->
      </div>
    </div>
    <div v-show="!detailDialog">
      <i class="el-icon-back" @click="goback"></i>
      <el-input
        placeholder="订单id"
        class="btn"
        size="mini"
        clearable
        v-model="orderId"
      ></el-input>
      <el-button type="primary" size="mini" @click="getdetailList({ page: 1 })"
        >明细搜索</el-button
      >
    </div>

    <el-divider></el-divider>
    <el-table
      :data="orderList"
      size="small"
      v-show="detailDialog"
      border
      height="calc(100vh - 360px)"
    >
      <el-table-column label="账户id" prop="accountId" fixed></el-table-column>
      <el-table-column label="用户类型" prop="userTypeName" fixed width="120">
        <template slot-scope="scope">{{ scope.row.userTypeName || "--" }}</template>
      </el-table-column>
      <el-table-column
        label="订单id"
        prop="orderId"
        fixed
        width="150px"
      ></el-table-column>
      <el-table-column
        label="交易对"
        prop="symbol"
        width="120px"
        align="center"
      ></el-table-column>
      <el-table-column label="委托数量" prop="origQty"></el-table-column>
      <el-table-column label="委托价格" prop="price"></el-table-column>
      <el-table-column
        label="已成交数量"
        prop="executedQty"
        align="center"
        width="140"
      ></el-table-column>
      <el-table-column label="手续费" align="center">
        <template slot-scope="scope">{{
          scope.row.fee == null ? "--" : scope.row.fee
        }}</template>
      </el-table-column>
      <el-table-column
        label="成交均价"
        prop="avgPrice"
        align="center"
      ></el-table-column>
      <el-table-column label="止盈/止损" min-width="120" align="center">
        <template slot-scope="scope">
          <span>{{ formatTpslPrice(scope.row.takeProfitTriggerPrice) }}</span>
          <span> / </span>
          <span>{{ formatTpslPrice(scope.row.stopLossTriggerPrice) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="下单方向" prop="orderSide" align="center">
        <template slot-scope="scope">{{
          scope.row.orderSide === 1 ? "买入" : "卖出"
        }}</template>
      </el-table-column>
      <el-table-column label="订单类型" prop="orderType">
        <template slot-scope="scope">{{
          scope.row.orderType === 1 ? "限价" : "市价"
        }}</template>
      </el-table-column>

      <el-table-column label="订单状态">
        <template slot-scope="scope">
          <span v-if="scope.row.state === 1">新建订单</span>
          <span v-else-if="scope.row.state === 2">部分成交</span>
          <span v-else-if="scope.row.state === 3">全部成交</span>
          <span v-else-if="scope.row.state === 4">用户撤销</span>
          <span v-else-if="scope.row.state === 5">下单失败</span>
          <span v-else>已过期</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" fixed="right" width="210px" align="center">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.state == 1 || scope.row.state == 2"
            :disabled="!$hasPerm('tenant:spot_order_limit:handle_cancle')"
            size="mini"
            type="warning"
            @click="handleCancle(scope.row)"
            >撤销订单</el-button
          >
          <el-button
            v-else
            size="mini"
            type="primary"
            @click="getDetail(scope.row)"
            >查看明细</el-button
          >
        </template>
      </el-table-column>

      <el-table-column label="创建时间" width="140px">
        <template slot-scope="scope">{{
          scope.row.createdTime | moment
        }}</template>
      </el-table-column>
      <el-table-column label="更新时间" width="140px">
        <template slot-scope="scope">{{
          scope.row.updatedTime | moment
        }}</template>
      </el-table-column>
    </el-table>
    <el-table :data="detailList" size="small" v-show="!detailDialog">
      <el-table-column label="账户id" prop="accountId" fixed></el-table-column>
      <el-table-column
        label="订单id"
        prop="orderId"
        fixed
        width="150px"
      ></el-table-column>
      <el-table-column
        label="交易对"
        prop="symbol"
        width="120px"
        align="center"
      ></el-table-column>
      <el-table-column label="成交数量" prop="quantity"></el-table-column>
      <el-table-column label="成交价格" prop="price"></el-table-column>
      <el-table-column label="手续费" align="center">
        <template slot-scope="scope">{{
          scope.row.fee == null ? "--" : scope.row.fee
        }}</template>
      </el-table-column>
      <el-table-column label="手续费币种" prop="feeCoin"></el-table-column>
      <el-table-column label="成交时间" width="140px">
        <template slot-scope="scope">{{
          scope.row.timestamp | moment
        }}</template>
      </el-table-column>
      <!-- <el-table-column label="操作" fixed="right" width="210px">
        <template slot-scope="scope">
          <el-button size="mini" type="warning" @click="handleCancle(scope.row)"
            >撤销订单</el-button
          >
          
        </template>
      </el-table-column> -->
    </el-table>
    <pagination
      v-show="detailDialog"
      :size="orderPagination.size"
      :total="totalCount"
      :page="orderPagination.page"
      @pageChanged="orderPageChanged"
    ></pagination>

    <pagination
      v-show="!detailDialog"
      :size="pagination.size"
      :total="detailTotalCount"
      :page="pagination.page"
      @pageChanged="pageChanged"
    ></pagination>

    <!-- <update-dialog :val="userinfoDetail" :updateForm="updateForm"></update-dialog> -->
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from "vuex";
import Pagination from "components/pagination";
import updateDialog from "../updatedialog";

export default {
  name: "OrderList",
  data() {
    return {
      // isRobot: "",
      defalutSymbolId: "",
      defalutAccountId: null,
      detailDialog: true,
      SearchOrderId: "",
      list: [],
      accountId: null,
      symbolId: "",
      orderPagination: {
        page: 1,
        size: 25,
      },
      updateForm: {},
      stateType: "",
      userRange: 1,
      orderType: "",
      orderSide: "",
      createdTimeRange: [],
      isRobotOptions: [
        { label: "全部", value: "" },
        { label: "机器人订单", value: true },
        { label: "非机器人订单", value: false },
      ],
      stateOptions: [
        { label: "全部", value: "" },
        { label: "新建订单", value: 1 },
        { label: "部分成交", value: 2 },
        { label: "全部成交", value: 3 },
        { label: "用户撤销", value: 4 },
        { label: "下单失败", value: 5 },
        { label: "已过期", value: 6 },
      ],
      orderTypeOptions: [
        { label: "全部", value: "" },
        { label: "限价", value: 1 },
        { label: "市价", value: 2 },
      ],
      orderSideOptions: [
        { label: "全部", value: "" },
        { label: "买入", value: 1 },
        { label: "卖出", value: 2 },
      ],
      userRangeOptions: [
        { label: "隐藏（仅普通用户）", value: 1 },
        { label: "显示（普通+模拟+特殊）", value: 2 },
      ],
      userTypes: {
        1: "无效用户",
        2: "普通用户",
        3: "初级股东",
        4: "中级股东",
        5: "高级股东",
      },
      updateUserTypeDialogVisible: false,
      newUserType: "",
      selectedForUserType: {},
      cacheRow: {},
      orderId: "",
    };
  },
  components: {
    Pagination,
    updateDialog,
  },
  methods: {
    ...mapActions("orderLimit", [
      "getOrderList",
      "getOrderDetails",
      "cancleOrder",
      "cancelAll",
      "getPairList",
      "exportExcel",
      "pagination",
    ]),
    ...mapMutations("orderLimit", [
      "setUserinfoDetailDialogVisible",
      "setUserinfoDetail",
    ]),
    formatTpslPrice(val) {
      if (val == null || val === "") return "——";
      return val;
    },
    buildQueryParams(extra = {}) {
      const startTime =
        this.createdTimeRange && this.createdTimeRange.length === 2
          ? new Date(`${this.createdTimeRange[0]} 00:00:00`).getTime()
          : null;
      const endTime =
        this.createdTimeRange && this.createdTimeRange.length === 2
          ? new Date(`${this.createdTimeRange[1]} 23:59:59`).getTime()
          : null;

      return {
        state: this.stateType === "" ? null : this.stateType,
        type: this.userRange,
        orderId: this.SearchOrderId,
        symbolId:
          this.defalutSymbolId === "" || this.defalutSymbolId === null
            ? null
            : Number(this.defalutSymbolId),
        page: this.orderPagination.page,
        size: this.orderPagination.size,
        accountId:
          this.defalutAccountId == "" ? null : Number(this.defalutAccountId),
        orderType: this.orderType === "" ? null : this.orderType,
        orderSide: this.orderSide === "" ? null : this.orderSide,
        startTime,
        endTime,
        ...extra,
      };
    },
    searchId() {
      this.orderPagination.page = 1;
      this.getOrderList(this.buildQueryParams());
    },
    getExcel() {
      const { page, size, ...params } = this.buildQueryParams();
      this.exportExcel(params).then((res) => {
        const blob = new Blob([res], { type: "application/vnd.ms-excel" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.download = "现货订单委托.xls";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      });
    },
    orderPageChanged(pagination) {
      this.orderPagination = pagination;
      this.getOrderList(this.buildQueryParams());
    },
    pageChanged(pagination) {
      this.getdetailList(pagination);
    },

    goback() {
      this.detailDialog = true;
    },
    //撤销所有订单
    cancelAllOrder() {
      this.$confirm("此操作将撤销所选用户所有订单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.cancelAll({
            accountId: Number(this.accountId),
            symbolId: this.symbolId,
          }).then((res) => {
            if (res.code == 0) {
              this.searchId();
              this.$message({
                type: "success",
                message: "撤销成功!",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消撤销",
          });
        });
    },
    //撤销订单
    handleCancle(row) {
      this.cancleOrder(row.orderId).then((res) => {
        if (res.code == 0) {
          this.searchId();
        }
      });
    },
    //查看成交明细
    getDetail(row) {
      this.detailDialog = false;
      this.cacheRow = row;
      this.getdetailList();
    },

    getdetailList(data) {
      this.getOrderDetails({
        orderId: this.orderId || this.cacheRow.orderId,
        ...this.pagination,
        ...data,
      });
    },
  },
  computed: {
    ...mapGetters("orderLimit", ["userList"]),
    ...mapState("orderLimit", [
      "pairList",
      "pagination",
      "totalCount",
      "userinfoDetail",
      "userinfoDetailDialogVisible",
      "orderList",
      "detailList",
      "detailTotalCount",
    ]),
  },

  mounted() {
    this.searchId();
    this.getPairList();
  },
};
</script>

<style lang="less" scoped>
.user-type-select {
  width: 100%;
}
.red {
  color: skyblue;
  font-weight: bold;
}
.el-icon-back:before {
  content: "\E6EA";
  font-size: 30px;
  cursor: pointer;
  line-height: 40px;
}
.el-icon-back {
  width: 40px;
  height: 40px;
}
.flex {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.btn {
  width: 160px;
  margin-right: 10px;
  margin-bottom: 5px;
}
.time-range {
  width: 260px;
}
.accountId {
  width: 180px;
}
.user-range {
  width: 220px;
}
.orderId {
  width: 200px;
}
</style>
